import { gsap } from "gsap";
import { observeAndAnimate } from "./utils";
// cta-banner
const ctaBanner = document.querySelector( "svg#globe-cta" );
if ( ctaBanner ) {
  let lines = ctaBanner.querySelectorAll( "path" );
  const circle = ctaBanner.querySelector( "circle" );
  gsap.to( circle, {
    y: -100,
    // scale: 0,
  } );
  const ctaTl = gsap.timeline( {
    paused: true,
    repeat: -1,
    // yoyo: true,
    defaults: { duration: 0.125, ease: "none" },
  } );
  lines = Array.from( lines ).slice( 0, 22 );

  lines.forEach( ( line, i ) => {
    const dasharray = "0.85 13.64";
    const stroke = "#7ABDFF";
    const strokeWidth = 2.55;
    if ( i != 0 ) {
      ctaTl.to( lines[ i - 1 ], {
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeDasharray: dasharray,
        // duration: 0.25,
      } );
    }
    ctaTl.to( line, {
      stroke: "#c0fa9c",
      strokeDasharray: "none",
      strokeWidth: 8,
      //   duration: 0.25,
    } );
  } );
  observeAndAnimate( "svg#globe-cta", ( element ) => {
    gsap.to( circle, {
      scale: 1,
      y: 0,
      onComplete: () => {
        ctaTl.play();
      },
    } );
  } );
}
